exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes feedbackAnimation {\n  0% { opacity: 0; transform: scale(0.5); }\n  35% { opacity: 1; }\n  100% { opacity: 0; transform: scale(1)}\n}\n", ""]);

// exports
